export const destructServerErrors = error => {
  if (error.response && error.response.data && error.response.data.errors) {
    return error.response.data.errors;
  }

  return '';
};

export const hasError = (errors, field) => {
  return !window._.isEmpty(errors[field]);
};

export const getError = (errors, field) => {
  let [error] = errors[field];
  return error;
};

export const hasErrors = (errors) => {
  let hasErrors = false;
  window._.forEach(errors, function(error, key){
    if(!window._.isEmpty(error)){
        hasErrors = true;
        return false;
    }
  })    
  return hasErrors;
};

export const allErrors = (errors) => {
  return window._.flattenDeep(window._.valuesIn(errors));
};
